<div class="form-row"  *ngIf="(alertesService.alerte$(labelAlerte) | async) && !(modeRendu.enModeImpression$ | async)">
    <div class="alert alert-{{colorErreur}} col-12">
        <div class="text-center align-middle">
            {{ libelle }}
        </div>
    </div>
</div>